export default __webpack_public_path__ + "static/media/baila2.58ff8c2c.png";